import React, { useState } from "react";
import "../../css/designSystem/Navbar.css";
import NavbarLogo from "../../assets/images/WPPLogo.png";
import OutlinedButton from "./OutlinedButton";
import FilledButton from "./FilledButton";
import { useNavigate } from "react-router-dom";

const Navbar = () => {
  const navigate = useNavigate();
  const [openDropdown, setOpenDropdown] = useState(null);
  const navItems = [
    {
      label: "Mortgages",
      dropdown: [{name:"Mortgages", link:"/mortgages"}, {name:"Calculators", link:"/calculators"}],
     
    },
    {
      label: "Protection",
      dropdown: [{name:"Business Protection", link:"/business-protection"}, {name:"Relevant Life Plan", link:"/relevant-life-plan"}],
    },
    {
      label: "Insurance",
      dropdown: [{name:"Life Insurance", link:"/life-insurance"}, {name:"Home Insurance", link:"/home-insurance"}, {name:"Landlord Insurance", link:"/landlord-insurance"}],
    },
    { label: "Testimonials", link: "/testimonials" },
    { label: "Blogs", link: "/blogs" },
    { label: "Our Team", link: "/our-team" },
  ];

  // Close dropdown on click outside
  React.useEffect(() => {
    const handleClick = (e) => {
      if (!e.target.closest(".navbar-links")) setOpenDropdown(null);
    };
    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, []);

  return (
    <nav className="navbar-fixed">
      <div className="navbar-container">
        <div className="navbar-logo-group">
          <img
            src={NavbarLogo}
            alt="WPP Financial Services Limited Logo"
            className="navbar-logo"
            onClick={() => navigate("/")}
          />
        </div>
        <ul className="navbar-links">
          {navItems.map((item, idx) => (
            <li
              key={item.label}
              className="help-text burgandy"
              style={{ position: "relative" }}
              onClick={() => {
                if (item.dropdown) {
                  setOpenDropdown(openDropdown === idx ? null : idx);
                } else {
                  setOpenDropdown(null);
                  if (item.link) navigate(item.link);
                }
              }}
            >
              {item.label}
              {item.dropdown && openDropdown === idx && (
                <div className="navbar-dropdown">
                  {item.dropdown.map((option) => (
                    <div
                      className="dropdown-item help-text burgandy"
                      key={option.name}
                      onClick={() => {
                        setOpenDropdown(null);
                        navigate(option.link);
                      }}
                    >
                      {option.name}
                    </div>
                  ))}
                </div>
              )}
            </li>
          ))}
        </ul>
        <div className="navbar-actions">
          <OutlinedButton
            text={"Contact"}
            onClick={() => {
              const el = document.getElementById("contact-us-section");
              if (el) {
                el.scrollIntoView({ behavior: "smooth" });
              } else {
                navigate("/#contact-us-section");
              }
            }}
          />
          <FilledButton
            text={"Client Portal"}
            onClick={() => navigate("/client-portal")}
          />
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
